import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Box } from '@mui/material';
import styles from './styles.module.scss';

export const ErrorInput: FC = () => {
  const { t } = useTranslation('common');

  return <Box className={styles.error}>{t('email.input.error')}</Box>;
};
